import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '100%',
    height: '40px',
    '& svg': {
      height: '90px',
    },
  },
  wrapper: {
    zIndex: 100,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    background: 'rgba(35, 51, 66, 0.3)',
  },
  fixed: {
    position: 'fixed',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    height: '100vh',
  },
  relative: {
    position: 'absolute',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
  },
  loader: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '30px',
    width: '160px',
    height: '160px',
    borderRadius: '100%',
    background: 'rgba(0, 0, 0, 0.1)',
    boxShadow: '0 0 20px 7px #fff inset, 0 0 15px 3px #fff',
    '& img': {
      height: '76px',
      display: 'block',
    },
    '&:before, &:after': {
      content: '""',
      position: 'absolute',

      width: '100%',
      height: '100%',
      borderRadius: '100%',
      border: '12px solid transparent',
      borderTopColor: '#0DD1C5',
    },
    '&:before': {
      zIndex: 100,
      animation: '$spin 1s infinite',
    },
    '&:after': {
      border: '12px solid #cff6f3',
    },
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
  loaderSpiner: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '30px',
    width: '90px',
    height: '90px',
    borderRadius: '100%',
    background: 'rgba(0, 0, 0, 0.1)',
    boxShadow: '0 0 20px 7px #fff inset, 0 0 15px 3px rgba(255, 255, 255, 0.7)',
    '& img': {
      height: '76px',
      display: 'block',
    },
    '&:before, &:after': {
      content: '""',
      position: 'absolute',

      width: '100%',
      height: '100%',
      borderRadius: '100%',
      border: '8px solid transparent',
      borderTopColor: '#0DD1C5',
    },
    '&:before': {
      zIndex: 100,
      animation: '$spin 1s infinite',
    },
    '&:after': {
      border: '8px solid #e7faf9',
    },
  },
}));
